import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import { point } from "@turf/helpers";
import type { Feature, Polygon, MultiPolygon } from "geojson";
import { Place } from "../Place";
import bariosGeoJSON from "../data/barrios.json";

export interface BarrioProperties {
  id: number;
  nombre: string;
  comuna: number;
}

export type BarrioFeature = Feature<Polygon | MultiPolygon, BarrioProperties>;

export function slugifyBarrio(nombre: string): string {
  return nombre
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/ñ/g, "n")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export const BARRIOS: BarrioFeature[] = (bariosGeoJSON as any).features;

export function getBarrioBySlug(slug: string): BarrioFeature | undefined {
  return BARRIOS.find((f) => slugifyBarrio(f.properties.nombre) === slug);
}

export function getAllBarrioSlugs(): { slug: string; nombre: string }[] {
  return BARRIOS.map((f) => ({
    slug: slugifyBarrio(f.properties.nombre),
    nombre: f.properties.nombre,
  })).sort((a, b) => a.nombre.localeCompare(b.nombre));
}

export function filterPlacesByBarrio(places: Place[], barrio: BarrioFeature): Place[] {
  return places.filter((p) =>
    booleanPointInPolygon(point([p.longi, p.lat]), barrio as any)
  );
}
